import React from 'react';
import * as R from 'ramda';
import {Alert, Badge} from 'reactstrap';
import {maybe, numberFormat, mapWithIndex} from '@/util';
import styles from '@/b2b/index.module.css';
import AmoebaLink from '@/components/AmoebaLink';
// import {Maybe} from 'monet';

const Item = ({data, installmentNo}) => {
  // const settledState = maybe(item.fullySettled)
  // .map(()=> ({className: 'danger', displayText: 'Fully Settled'}))
  // .map(()=> { return {className: 'danger', displayText: 'Fully Settled'}})
  // .orElse({className: 'success', displayText: 'Not Yet Fully Settled'})

  const settledState = R.ifElse(
    R.equals(true),
    R.always({className: 'danger', displayText: 'Fully Settled'}),
    R.always({className: 'success', displayText: 'Not Yet Fully Settled'})
  )(data.fullySettled);

  return (
    <tr>
      <td>
        <div className='badge badge-pill badge-success'>{installmentNo}</div>
      </td>
      <td>
        <div className={styles.align_left}>
          <div className={styles.payin_item}>
            <div
              className={`${styles.payin_item_detail} badge badge-${
                settledState.className
              }`}
            >
              {settledState.displayText}
            </div>
            <div className={styles.payin_settlement_detail}>
              <div className={styles.payin_settlement_detail_heading}>
                <Badge color='badge badge-info'>Settlement Details</Badge>
              </div>
              <div className={styles.payin_settlement_item_detail}>
                <Badge color='success'>1</Badge>
                <AmoebaLink href='/settlements/1526'>
                  {maybe(data.settlementList)
                    .map(settlementList => settlementList[0].refNo)
                    .orElse('N/A')}
                </AmoebaLink>
                <div className='badge badge-secondary'>Revenue Month</div>
                {maybe(data.settlementList)
                  .map(settlementList => settlementList[0].cutoffOn)
                  .orElse('N/A')}
                <div className='badge badge-secondary'>Actual Receive Date</div>
                {maybe(data.settlementList)
                  .map(settlementList => settlementList[0].actualReceiveOn)
                  .orElse('N/A')}
                <div className='badge badge-secondary'>Settled Amount</div>
                {maybe(data.settlementList)
                  .map(settlementList =>
                    numberFormat.toDollar(settlementList[0].settledAmount)
                  )
                  .orElse('N/A')}
              </div>
            </div>
          </div>
        </div>
      </td>
      <td className='text-right'>
        {maybe(data.settlementList)
          .map(settlementList =>
            R.join(' / ', R.map(item => item.cutoffOn, R.uniq(settlementList)))
          )
          .orElse('N/A')}
      </td>
      <td className='text-right'>{data.projectedReceiveOn}</td>
      <td className='text-right'>
        {maybe(data.settlementList)
          .map(settlementList =>
            R.join(
              ' / ',
              R.map(item => item.actualReceiveOn, R.uniq(settlementList))
            )
          )
          .orElse('N/A')}
      </td>
      <td className='text-right'>
        {numberFormat.toPercentage(data.groupPayinRate, 4)}
      </td>
      <td className='text-right'>
        {numberFormat.toDollar(data.totalPayAmount)}
      </td>
      <td className='text-right'>
        {numberFormat.toDollar(data.totalSettledAmount)}
      </td>
      <td className='text-right'>
        {numberFormat.toDollar(data.totalOutstandingAmount)}
      </td>
    </tr>
  );
};

const ItemList = ({items, installmentNoInitVal}) => {
  if (items.length <= 0) {
    return (
      <Alert color='primary' className='text-center'>
        {' '}
        N/A{' '}
      </Alert>
    );
  }

  return (
    <table className='table table-striped payin'>
      <colgroup>
        <col width='5%' />
        <col width='10%' />
        <col width='10%' />
        <col width='10%' />
        <col width='10%' />
        <col width='10%' />
        <col width='15%' />
        <col width='15%' />
        <col width='15%' />
      </colgroup>
      <thead>
        <tr>
          <th>#</th>
          <th>&nbsp;</th>
          <th className='text-right'>Revenue Month</th>
          <th className='text-right'>
            Projected
            <br />
            Receive Date
          </th>
          <th className='text-right'>
            Actual
            <br />
            Receive Date
          </th>
          <th className='text-right'>Rate</th>
          <th className='text-right'>Entitled Amount</th>
          <th className='text-right'>Settled Amount</th>
          <th className='text-right'>Outstanding Amount</th>
        </tr>
      </thead>
      <tbody>
        {mapWithIndex(
          (data, idx) => (
            <Item
              key={`payin_item_${idx}`}
              installmentNo={idx + 1 + installmentNoInitVal}
              data={data}
            />
          ),
          items
        )}
      </tbody>
    </table>
  );
};

export default ItemList;
